export const getConfiguration = async ($fire: any) => {
  return await $fire.firestore
    .collection('tools')
    .doc('preventions')
    .collection('configuration')
    .get()
}
